import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosPrivate from "../../hooks/axiosPrivate";
import Home from "./home/Home";
import AboutUsPage from "./aboutus/AboutUs";
import Blog from "./pages/Blog";
import DistributorPage from "./DistributorPage/DistributorPage";
import { useContext } from "react";
import LoaderContext from './../../context/Loader/LoaderContext'
import ProductDinamicPage from "./MarketplaceProducts/ProductDinamicPage";
import SEO from "../common/SEO";

const CommonTemplate = () => {
  const { slug } = useParams();
  const [mode, setMode] = useState(slug);
  const [pageData, setPageData] = useState({});
  const [dynamicTagName, setDynamicTagName] = useState("");
  const { setLoaderCheck } = useContext(LoaderContext);

  useEffect(() => {

    window.scroll({
      top: 0,
      behavior: "smooth"
    })

    const fetchData = async () => {
      // Fetch your page data here or use it from the state or props

      if (slug) {
        var mode_local = slug.replace("%20", '-').replace(" ", "-");
        setMode(mode_local);

      }

      else {
        mode_local = 'home';
        setMode(mode_local);
      }

      const getPageBySlug = (mode_local) => {
        setLoaderCheck(true);
        axiosPrivate
          .get("pages/slug/" + mode_local)
          .then((res) => {
            setLoaderCheck(false);

            const fetchedPageData = res.data.data;
            setPageData(JSON.parse(fetchedPageData.page_json));
            setDynamicTagName(fetchedPageData.template_type);
          })
          .catch((error) => {
            setLoaderCheck(false);
          });
      };
      getPageBySlug(mode_local);
    };
    fetchData();
  }, [slug]);


  const renderDynamicComponent = () => {
    switch (dynamicTagName) {
      case "product":
        return <ProductDinamicPage initialValues={pageData} />;
      case "about":
        return <AboutUsPage initialValues={pageData} />;
      case "home":
        return <Home pageData={pageData} />;
      case "blog":
        return <Blog pageData={pageData} />;
      case "distributor":
        return <DistributorPage pageData={pageData} />;
      // Add additional cases for other dynamic components
      default:
        return <Home pageData={pageData} />;
    }


  };

  // return renderDynamicComponent();


  return (
    <>
      <SEO
        title={pageData?.meta_title || "MINFERT - Premium Agricultural Solutions & Organic Products"}
        description={pageData?.meta_description || "Leading provider of certified organic agricultural products and solutions. Enhance your farming with MINFERT's eco-friendly fertilizers and crop solutions."}
        keywords={pageData?.keywords || "agriculture, organic farming, fertilizers, crop solutions, sustainable farming"}
        tags={pageData?.tags}
        canonical={pageData?.canonical_tags || "https://minfert.in"}
        ogTitle={pageData?.og_title || "MINFERT - Agricultural Excellence"}
        ogDescription={pageData?.og_description || "Transform your farming with our premium organic solutions"}
        ogImage={pageData?.og_image || "https://minfert.in/assets/images/home/logo.webp"}
        ogUrl={pageData?.og_url}
        structuredData={pageData?.structured_data}
        FAQSchema={pageData?.product_FAQ_schema}
        headSchema={pageData?.head_schema}
        bodySchema={pageData?.body_schema}
      />
      {renderDynamicComponent()}
    </>
  );
};

export default React.memo(CommonTemplate); // Memoize the CommonTemplate;
